import React, { Component } from "react";
import Navbar from "../../components/newNavBar";
import Loader from "../../utils/loader";
import less from "./wallet.module.scss";
import { message, DatePicker, Table, Modal } from "antd";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { Fetch } from "../../utils/fetch";
import jwt from "../../utils/jwt";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage, businessModelType } from "../../config";
const { RangePicker } = DatePicker;

const columns = [
  {
    title: "Bus RC",
    dataIndex: "rc",
    key: "rc",
    width: "25%",
  },
  {
    title: "Transaction Code",
    dataIndex: "code",
    key: "code",
    width: "25%",
  },
  {
    title: "Transaction Amount",
    dataIndex: "amount",
    key: "amount",
    width: "10%",
  },
  {
    title: "Closing Amount",
    dataIndex: "closingAmount",
    key: "closingAmount",
    width: "10%",
  },
  {
    title: "Transaction Type",
    dataIndex: "type",
    key: "type",
    width: "15%",
  },
  {
    title: "Energy Units",
    dataIndex: "eUnits",
    key: "eUnits",
    width: "15%",
  },
  {
    title: "Energy Charge Per Unit",
    dataIndex: "ePerUnit",
    key: "ePerUnit",
    width: "15%",
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "location",
    width: "15%",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "25%",
  },
  {
    title: "Created On",
    dataIndex: "createdOn",
    key: "createdOn",
    width: "15%",
  },
];

class kyc extends Component {
  state = {
    loading: true,
    fromDate: moment().subtract(1, "week").startOf("day").valueOf(),
    toDate: moment().endOf("day").valueOf(),
  };

  async componentDidMount() {
    try {
      const stateObj = { loading: false };
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      const userMobileNo = decodedToken.mobileNo;

      let userType = decodedToken.userType || "OPERATOR";
      if (sessionStorage.getItem("userType")) {
        userType = sessionStorage.getItem("userType");
      } else if (decodedToken && decodedToken.isElectricUser) {
        userType = "ELECTRIC";
      }
      stateObj.userType = userType;

      stateObj.mobileNo = userMobileNo;
      stateObj.loading = false;
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      stateObj.balance = await this.fetchWalletDetails(userMobileNo);
      stateObj.transactions = await this.fetchPayouts(
        this.state.fromDate,
        this.state.toDate
      );
      this.setState(stateObj);
    } catch (err) {
      console.log(err);
    }
  }

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  fetchWalletDetails = async (userMobileNo) => {
    const url = `/user/details?mobileNo=${userMobileNo}`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);
    if (response) {
      return response[0].walletBalance;
    } else {
      message.error("no data found");
      return;
    }
  };

  fetchPayouts = async (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      fromDate = this.state.fromDate;
      toDate = this.state.toDate;
    }
    const url = `/user/trasactions?fromDate=${fromDate}&toDate=${toDate}`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);
    if (response) {
      const formatResponse = response.map((item) => {
        return {
          rc:item.busRc,
          eUnits:`${item.totalEnergy} kw`,
          ePerUnit:`₹${item.energyChargeRate}`,
          location:item.location,
          code: item.transactionCode,
          amount: `₹${item.amount}`,
          closingAmount: `₹${item.closingBalance}`,
          type: item.transactionType,
          description: item.description,
          key: item._id,
          createdOn: moment(item.transactionTime).format("DD/MM/YYYY HH:mm"),
        };
      });
      return formatResponse;
    } else {
      message.error("no data found");
      return;
    }
  };

  fetchPayoutsOnDates = async () => {
    const transactions = await this.fetchPayouts(
      this.state.fromDate,
      this.state.toDate
    );
    this.setState({ transactions, enterDateModal: false });
  };

  onTimeRangeSelect = async (dates, dateStrings) => {
    let fromDate, toDate;
    if (dates) {
      fromDate = moment(dateStrings[0], "DD/MM/YYYY").valueOf();
      toDate = moment(dateStrings[1], "DD/MM/YYYY").endOf("day").valueOf();
      this.setState({ fromDate, toDate });
    } else {
      console.log("Clear");
    }
  };

  handleAmountChange = (value) => {
    this.setState({ amount: value });
  };

  openTransactionPage = async () => {
    const { amount, mobileNo } = this.state;
    const url = `/user/addMoney`;
    const options = {
      method: "post",
      data: {
        mobileNo,
        amount,
      },
    };

    const response = await Fetch(url, options);
    if (response) {
      window.open(response.web, "_self");
    } else {
      message.error("some error occured, please try again later");
    }
  };

  showTransaction = (item) => {
    this.setState({ showTransactionDetails: true, showTransactionsOf: item });
  };

  openTopUpPage = () => {
    const { userType, mobileNo } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    const business_model_type = businessModelType.find(
      (opt) => opt.value === userType
    )?.label;
    mixpanel.track("Top Up Wallet Clicked", {
      view_from: "WALLET Page",
      type: userType === "ELECTRIC" ? "BUSOWNER" : userType,
      mobile_number: mobileNo,
      business_model_type,
    });
    this.setState({ enterAmountModal: true, amount: undefined });
  };

  render() {
    const {
      loading,
      isMobile,
      showSideMenu,
      balance = 0,
      showTransactionDetails = false,
      showTransactionsOf,
      transactions = [],
      amount = undefined,
      enterAmountModal = false,
      enterDateModal = false,
    } = this.state;
    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <div>
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={7}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          <div class="container">
            <div className={less.header}>
              <span>Wallet Details</span>
              <span>View complete details of your transactions</span>
            </div>
            <div className={less.content}>
              <div className={less.topUp}>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operator/walletMoney.svg"
                  alt="wallet"
                />
                <div>
                  <span>Wallet Balance</span>
                  <span>
                    <b>{balance}</b>
                  </span>
                </div>
                <button onClick={this.openTopUpPage}>Top Up Wallet</button>
              </div>
              <div className={less.filter}>
                <span>Recent Transactions</span>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorWallet/filter.svg"
                  onClick={() => this.setState({ enterDateModal: true })}
                />
              </div>
              <div className={less.table}>
                {transactions.map((item) => (
                  <div
                    onClick={() => this.showTransaction(item)}
                    className={less.transactionCard}
                    key={item.key}
                  >
                    <div>
                      <img
                        src={
                          item.transactionType === "DEBIT"
                            ? "https://d1flzashw70bti.cloudfront.net/original/images/operaotr/wallet/debit.svg"
                            : "https://d1flzashw70bti.cloudfront.net/original/images/operaotr/wallet/credit.svg"
                        }
                        alt="icon"
                      />
                      <div>
                        <span>{item.amount}</span>
                        <span>
                          {" "}
                          {moment(item.transactionTime).format(
                            "DD MMM YYYY hh:mm A"
                          )}
                        </span>
                      </div>
                    </div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/waller/leftarrow.svg"
                      alt="left-arrow"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Modal
            title="Add Money to zingbus Wallet"
            centered
            open={enterAmountModal}
            onCancel={() =>
              this.setState({ enterAmountModal: false, amount: undefined })
            }
            footer={null}
            closeIcon={null}
          >
            <div className={less.amountEnter}>
              <div>
                <span>Amount</span> <span>*</span>
              </div>
              <div>
                <span>₹</span>
                <input
                  placeholder="Enter amount here"
                  onChange={(e) =>
                    this.handleAmountChange(e.target.value.replace(/\D/g, ""))
                  }
                  value={amount}
                ></input>
              </div>
              <div>
                <button
                  onClick={() =>
                    this.setState({
                      enterAmountModal: false,
                      amount: undefined,
                    })
                  }
                >
                  Cancel
                </button>
                <button onClick={this.openTransactionPage}>Add Money</button>
              </div>
            </div>
          </Modal>
          <Modal
            title="Filters"
            centered
            open={enterDateModal}
            onCancel={() => this.setState({ enterDateModal: false })}
            footer={null}
            closeIcon={null}
          >
            <div className={less.dateEnter}>
              <div>
                <span>Choose Date</span> <span>*</span>
              </div>
              <div>
                <RangePicker
                  width="100%"
                  format="DD/MM/YYYY"
                  onChange={this.onTimeRangeSelect}
                />
              </div>
              <div>
                <button
                  onClick={() =>
                    this.setState({
                      enterDateModal: false,
                    })
                  }
                >
                  Cancel
                </button>
                <button onClick={this.fetchPayoutsOnDates}>Apply</button>
              </div>
            </div>
          </Modal>
          {showTransactionDetails ? (
            <Modal
              title="All Transaction Details"
              centered
              open={showTransactionDetails}
              onCancel={() =>
                this.setState({
                  showTransactionDetails: false,
                })
              }
              footer={null}
              closeIcon={null}
            >
              <div className={less.transactionInfoCard}>
                 <div className={less.transactionContent}>
                  <span>RC</span>
                  <span>{showTransactionsOf.rc}</span>
                </div>
                <div className={less.transactionContent}>
                  <span>Transaction Code</span>
                  <span>{showTransactionsOf.code}</span>
                </div>
                <div className={less.transactionInfo}>
                  <div className={less.transactionContent}>
                    <span>Transaction Amount</span>
                    <span>{showTransactionsOf.amount}</span>
                  </div>
                  <div className={less.transactionContent}>
                    <span>Created On</span>
                    <span> {showTransactionsOf.createdOn}</span>
                  </div>
                </div>
                <div className={less.transactionInfo}>
                  <div className={less.transactionContent}>
                    <span>Transaction Type</span>
                    <span>{showTransactionsOf.type}</span>
                  </div>
                  <div className={less.transactionContent}>
                    <span>Closing Amount</span>
                    <span>{showTransactionsOf.closingAmount}</span>
                  </div>
                </div>
                  <div className={less.transactionInfo}>
                  <div className={less.transactionContent}>
                    <span>Energy Unit</span>
                    <span>{showTransactionsOf.eUnits}</span>
                  </div>
                  <div className={less.transactionContent}>
                    <span>Energy Charge Per Unit</span>
                    <span>{showTransactionsOf.ePerUnit}</span>
                  </div>
                </div>
                <div className={less.transactionContent}>
                  <span>Location</span>
                  <span>{showTransactionsOf.location}</span>
                </div>
                <button
                  onClick={() =>
                    this.setState({
                      showTransactionDetails: false,
                    })
                  }
                >
                  Close
                </button>
              </div>
            </Modal>
          ) : null}
        </div>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={7.1} isMobile={isMobile} />
          <div class="container">
            <div className={less.header}>
              <span>Wallet Details</span>
              <span>View complete details of your transactions</span>
            </div>
            <div className={less.topUp}>
              <div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operator/walletMoney.svg"
                  alt="wallet"
                />
                <span>
                  Wallet Balance : <b>{balance}</b>
                </span>
              </div>
              <button onClick={this.openTopUpPage}>Top Up Wallet</button>
            </div>
            <div className={less.filter}>
              <span>Recent Transactions</span>
              <div>
                <RangePicker
                  format="DD/MM/YYYY"
                  onChange={this.onTimeRangeSelect}
                />
                <button onClick={this.fetchPayoutsOnDates}>Apply</button>
              </div>
            </div>
            <div className={less.table}>
              <Table
                columns={columns}
                bordered={true}
                dataSource={transactions}
                pagination={false}
              />
            </div>
          </div>
          <Modal
            title="Add Money to zingbus Wallet"
            centered
            width={"fit-content"}
            open={enterAmountModal}
            onCancel={() =>
              this.setState({ enterAmountModal: false, amount: undefined })
            }
            footer={null}
            closeIcon={null}
          >
            <div className={less.amountEnter}>
              <div>
                <span>Amount</span> <span>*</span>
              </div>
              <div>
                <span>₹</span>
                <input
                  placeholder="Enter amount here"
                  onChange={(e) =>
                    this.handleAmountChange(e.target.value.replace(/\D/g, ""))
                  }
                  value={amount}
                ></input>
              </div>
              <div>
                <button
                  onClick={() =>
                    this.setState({
                      enterAmountModal: false,
                      amount: undefined,
                    })
                  }
                >
                  Cancel
                </button>
                <button onClick={this.openTransactionPage}>Add Money</button>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default kyc;
